const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaTipo: [],
	listaStatus: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PROCESSO_FINANCEIRO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'PROCESSO_FINANCEIRO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        case 'PROCESSO_FINANCEIRO_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
			};

        case 'PROCESSO_FINANCEIRO_STATUS_SELECT_LISTADO':
			return {
				...state,
				listaStatus: action.payload.data
			};

        default:
            return state;
    }
}
